const HasPermission = (moduleName, permissionType) => {
  const userPermissions = JSON.parse(localStorage.getItem("userPermissions")) || []
  if (userPermissions.length < 1) return true;
  const module = userPermissions.find(
    (m) => m.moduleName.toLowerCase() === moduleName.toLowerCase() && m.isMainModule == "0"
  );

  if (!module) return false;
  return module[permissionType] === "1";
};

export { HasPermission };

//  && m.status === "1"
